import AuthShield from '@/auth/AuthShield';
import Login from '@/auth/Login';
import BookDetails from '@/pages/Books/BookDetails';
import Dashboard from '@/pages/Dashboard/Dashboard';
import Elements from '@/pages/Elements';
import NotFound from '@/pages/Errors/NotFound';
import UserProfile from '@/pages/Users/UserProfile';
import Users from '@/pages/Users/Users';
import Socket from '@/services/Socket';
import { createBrowserRouter } from 'react-router';
import Layout from '../layout/Layout';
import Books from '../pages/Books/Books';
import Settings from '../pages/Settings/Settings';
import Tickets from '../pages/Tickets/Tickets';
import TicketDetailPage from '../pages/Tickets/TicketDetailPage';
import TicketCharts from '@/pages/Charts/TicketCharts/TicketCharts';
import UserCharts from '@/pages/Charts/UserCharts/UserCharts';
import BookCharts from '@/pages/Charts/BookCharts/BookCharts';
import Notifications from '@/pages/Notifications/Notifications';
import Categories from '@/pages/Categories/Categories';
import Subcategories from '@/pages/Subcategories/Subcategories';

export const appRouting = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthShield>
        <Socket>
          <Layout />
        </Socket>
      </AuthShield>
    ),
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/users', element: <Users /> },
      { path: '/users/profile', element: <UserProfile userId={undefined} /> },
      { path: '/books', element: <Books /> },
      { path: '/books/:id', element: <BookDetails /> },
      { path: '/categories', element: <Categories /> },
      { path: '/subcategories', element: <Subcategories /> },
      { path: '/tickets', element: <Tickets /> },
      { path: '/tickets/:id', element: <TicketDetailPage /> },
      { path: '/analysis/users', element: <UserCharts /> },
      { path: '/analysis/books', element: <BookCharts /> },
      { path: '/analysis/tickets', element: <TicketCharts /> },
      { path: '/notifications', element: <Notifications /> },
      { path: '/settings', element: <Settings /> },
      { path: '/elements', element: <Elements /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  { path: '/login', element: <Login /> },
]);
